import { render, staticRenderFns } from "./ItemAutoMemberModal.vue?vue&type=template&id=2c93200a&scoped=true&"
import script from "./ItemAutoMemberModal.vue?vue&type=script&lang=js&"
export * from "./ItemAutoMemberModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c93200a",
  null
  
)

export default component.exports